import { ErpDiv } from './ErpHtml';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateApiErrorMessage } from '@/utils/translateMessage';

export interface ErpFormInvalidFeedbackProps extends React.HTMLAttributes<HTMLDivElement> {
  forceShow?: boolean;
  state?: boolean | null;
  tooltip?: boolean;
}

export const ErpFormInvalidFeedback: React.FC<ErpFormInvalidFeedbackProps> = ({
  forceShow,
  state,
  tooltip: _tooltip,
  children,
  className,
  ...props
}) => {
  const { t } = useTranslation();
  const visible = state === false;
  if (!forceShow && !visible) return null;

  const content = typeof children === 'string' ? translateApiErrorMessage(children, t) : children;

  return (
    <ErpDiv
      role="alert"
      {...props}
      className={['text-[0.8rem] font-medium text-red-700 dark:text-red-300 mt-1 break-words', (forceShow || visible) && 'block', className].filter(Boolean).join(' ')}
    >
      {content}
    </ErpDiv>
  );
};
